"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiUserSession = void 0;
var ApiManager_1 = require("../ApiManager");
/**
 * 사용자 세션(로그아웃) 관리
 */
var ApiUserSession = /** @class */ (function (_super) {
    __extends(ApiUserSession, _super);
    function ApiUserSession() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ApiUserSession.getInstance = function (initValue) {
        if (!ApiUserSession.classInstance) {
            this.classInstance = new ApiUserSession(initValue);
        }
        return this.classInstance;
    };
    ApiUserSession.prototype.addUserSessionController = function (errorCallback, serverLocale, serverVersion, receivedUserId) {
        this.userInterceptor(errorCallback);
        // 서버 정보 반영하기
        var defaultCallback = {
            callback: function (locale, localeString) {
                serverLocale(locale, localeString);
            },
            callbackServerVersion: function (version) {
                serverVersion(version);
            },
            callbackUserId: function (userId) {
                receivedUserId(userId);
            },
        };
        this.defaultInterceptor(defaultCallback);
    };
    return ApiUserSession;
}(ApiManager_1.ApiManager));
exports.ApiUserSession = ApiUserSession;
